import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { cleanJoin } from "../../utils/stringUtil";
import "./Checkbox.scss";

function Checkbox({ label, checked = false, onChange, labelClassName }) {
  return (
    <div className="checkbox-container" onClick={onChange}>
      <div
        className={`checkbox-outer-box is-clickable has-border-grey-1-important has-background-white`}
      >
        {checked && (
          <FontAwesomeIcon icon={faCheck} className={"checkbox-tick has-text-grey-dark"} />
        )}
      </div>
      <div className={cleanJoin("checkbox-label", labelClassName)}>{label}</div>
    </div>
  );
}

export default Checkbox;
